import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { OrderItem } from '../../services/order/GetOrders.interface';
import { OrderService } from '../../services/order/order.service';

export interface CancelOrderComponentData {
  OrderId: number;
  OrderNo: string;
  OrderItems: OrderItem[];
  IsOrderDeskOrder: boolean;
}
export interface OrderItemToCancel {
  CartItemId: number;
  Quantity: number;
}

@Component({
  selector: 'app-order-cancel',
  templateUrl: './order-cancel.component.html',
  styleUrls: ['./order-cancel.component.scss']
})
export class OrderCancelComponent implements OnInit {

  order: CancelOrderComponentData;
  cancelOrderForm: FormGroup;
  prevOrderItems: number[];
  orderItemsToCancel: OrderItemToCancel[];

  constructor(
    private formBuilder: FormBuilder,
    private loader: LoaderService,
    private toaster: ToastrService,
    private orderService: OrderService,
    public dialogRef: MatDialogRef<OrderCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelOrderComponentData) { }

  ngOnInit(): void {
    this.prevOrderItems = [0];
    this.order = this.data;
    this.cancelOrderForm = this.formBuilder.group({
      orderItems: new FormControl([0], Validators.compose([Validators.required])),
      notes: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.cancelOrderForm.controls;
  }

  fn_ChangeSelectProducts(event) {
    const selected = event.value.filter((n: any) => !this.prevOrderItems.includes(n));
    if (selected && selected.some((x: number) => x == 0)) {
      this.cancelOrderForm.get("orderItems").patchValue([0]);
      this.prevOrderItems = [0];
    }
    else {
      const exceptAll = event.value.filter(function (ele: number) {
        return ele != 0;
      });
      this.cancelOrderForm.get("orderItems").patchValue(exceptAll);
      this.prevOrderItems = exceptAll;
    }
    this.orderItemsToCancel = this.cancelOrderForm.value.orderItems.map((x: number) => {
      let item = this.order.OrderItems.find(i => i.CartItemId == x);
      return {
        CartItemId: x,
        Quantity: item.Quantity
      };
    });
  }

  fn_DecrementQty(item: OrderItemToCancel) {
    if (item.Quantity > 1)
      item.Quantity = item.Quantity - 1;
  }
  fn_IncrementQty(item: OrderItemToCancel) {
    let orderItem = this.order.OrderItems.find(i => i.CartItemId == item.CartItemId);
    if (item.Quantity < orderItem.Quantity)
      item.Quantity = item.Quantity + 1;
  }

  fn_GetProduct(cartItemId: number) {
    const product = this.order.OrderItems.find(x => x.CartItemId == cartItemId);
    return product;
  }
  fn_ShowCancelProductList() {
    const allExist = this.cancelOrderForm.value.orderItems.some((x: number) => x == 0);
    return !allExist;
  }

  fn_Submit() {
    let value = this.cancelOrderForm.value;
    let data = {
      OrderId: this.order.OrderId,
      Comment: value.notes,
      Items: this.orderItemsToCancel,
      IsOrderDeskOrder: this.order.IsOrderDeskOrder
    };
    this.loader.show();
    this.orderService.RequestCancelOrder(data).subscribe(res => {
      this.loader.hide();
      if (res.StatusCode === 200) {
        this.cancelOrderForm.reset();

        this.toaster.success('Your request has been submitted', 'Success');
        this.dialogRef.close({ isSubmit: true });
      }
      else {
        this.dialogRef.close({ isSubmit: true });
        this.toaster.error(res.Message, 'Error');
      }
    });
  }
}
